/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import store from "modules/projects/store";
import publicLocale from "./i18n/public.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "my-subscriptions" },
      title: "projects.menuItems.mySubscriptions",
      icon: "redo",
      hideNoAuth: true
    },
    {
      to: { name: "my-projects" },
      title: "projects.menuItems.myProjects",
      icon: "project-diagram",
      hideNoAuth: true
    }
  ],
  routes: [
    {
      path: "/mijn-abonnementen",
      name: "my-subscriptions",
      meta: {
        auth: true,
        title: "projects.menuItems.mySubscriptions"
      },
      component: () => import("./pages/MySubscriptions.vue")
    },
    {
      path: "/mijn-projecten",
      name: "my-projects",
      meta: {
        auth: true,
        title: "projects.menuItems.myProjects"
      },
      component: () => import("./pages/MyProjects.vue")
    }
  ],
  storeModules: {
    projects: store
  },
  widgets: [
    {
      name: "ProjectInfo",
      component: () => import("./widgets/ProjectInfo.vue")
    },
    {
      name: "SubscriptionInfo",
      component: () => import("./widgets/SubscriptionInfo.vue")
    }
  ],
  localisation: { key: "projects", messages: publicLocale }
};

export default manifest;
